import React, {ReactNode} from 'react'

import {Button} from '@vio/atlas/Button'
import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Grid} from '@vio/atlas/helpers/Grid'
import {Text} from '@vio/atlas/Text'
import {
  BookingError,
  Psd2AuthStatusErrorType
} from '@vio/core/src/booking/types/ErrorResponse'
import {getRecoverableErrorMessages} from '@vio/core/src/booking/utils/bookingErrorHelpers'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {DateAndRoomsText} from '../../search/DateAndRoomsText'
import {ErrorMessagesLayout} from './ErrorMessagesLayout'

interface PropsType {
  checkIn: string
  checkOut: string
  rooms: string
  onClick: () => void
  bookingError: BookingError | Psd2AuthStatusErrorType
  redirectOffersSlot: ReactNode
  hotelCardSlot: ReactNode
  isPayAtProperty?: boolean
}

export const RecoverableErrorContentLayout = ({
  checkIn,
  checkOut,
  rooms,
  onClick = () => {},
  bookingError,
  redirectOffersSlot,
  hotelCardSlot,
  isPayAtProperty = false
}: PropsType) => {
  const errorMessage = getRecoverableErrorMessages(
    bookingError,
    isPayAtProperty
  )
  if (!errorMessage) return null

  return (
    <Box padding="s500">
      <Grid gap="s500">
        <ErrorMessagesLayout
          titleSlot={<FormattedMessageWrapper {...errorMessage.title} />}
          descriptionSlot={
            <FormattedMessageWrapper
              {...errorMessage.description}
              values={{br: () => <br />}}
            />
          }
        />

        <Box display="flex" flexDirection="column" gap="s600">
          <Button size="xl" variant="tertiary" fullWidth onClick={onClick}>
            <FormattedMessageWrapper
              id="chooseAnotherProperty"
              defaultMessage="Back to property"
            />
          </Button>

          <Divider />
          <Box display="flex" flexDirection="column" gap="s400">
            <Text
              variant="bodyM"
              colorPath="content.neutral.secondary"
              align="center"
              dataId="errors.alternativeDealsText"
            >
              <FormattedMessageWrapper
                id="errors.alternativeDealsText"
                defaultMessage="Check out these similar deals from our trusted partners:"
              />
            </Text>
            <Box display="flex" justifyContent="center">
              <DateAndRoomsText
                checkIn={checkIn}
                checkOut={checkOut}
                rooms={rooms}
                hasCustomStyle
              />
            </Box>
          </Box>
        </Box>
        <Box paddingTop="s400">
          {hotelCardSlot}
          {redirectOffersSlot}
        </Box>
      </Grid>
    </Box>
  )
}
